// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f3511634","455":"918b45c1","977":"ee32a9a9"}[chunkId] + ".chunk.js";
};